import React from 'react'
import { PrismicLink } from '@prismicio/react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const CategoryCard = ({ item }) => {
  const itemData = item.node.data

  return (
    <li className='component-card ease relative transform rounded border overflow-hidden bg-white shadow transition duration-300 group ease-in-out hover:shadow-lg hover:shadow-cyan-800/1'>
      <PrismicLink className={`grid h-full ${itemData.page_image ? `grid-row-2` : `text-center grid-rows-1`}`} href={item.node.url}>
        <div className='m-3 md:m-6'>
          <div className='text-stone-500 text-sm text-right'>{itemData.date_fromnow_formatted}</div>
          <div className='text-lg'>
            <h3 className='text-cyan-700 group-hover:text-blue-950 font-semibold'>{itemData.page_title.text}</h3>
            {(itemData.start_date_and_time || itemData.end_date_and_time) && (
              <>
                {itemData.start_date_formatted === itemData.end_date_formatted ? itemData.start_date_formatted : `${itemData.start_date_formatted} to ${itemData.end_date_formatted}`}
                <div className='text-sm text-stone-500'>
                  {itemData.start_time_formatted && itemData.start_time_formatted} - {itemData.end_time_formatted && itemData.end_time_formatted}
                </div>
              </>
            )}
          </div>
        </div>
        {itemData.page_image && (
          <div className='overflow-hidden relative aspect-video'>
            <GatsbyImage className='group-hover:scale-110 transition duration-500 bg-cover inset-0 absolute h-full' image={getImage(itemData.page_image)} alt={itemData.page_image?.alt || ''} />
          </div>
        )}
      </PrismicLink>
    </li>
  )
}

export default CategoryCard
